import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Pagination,
  Skeleton,
  Snackbar,
  TextField,
  Typography
} from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import MainCard, {
  ErrorScreen,
  Search,
  SearchIconWrapper,
  SnackBarHideDuration,
  SnackBarTransition,
  StyledInputBase,
  stringAvatar
} from '../../utils/ui_utils'
import { Phone } from '@mui/icons-material'
import { useNavigate } from 'react-router'
import { businessCheck } from '../../utils/utils'
import LedgerEntryDialog from './ledgerEntry/ledgerEntryDialog'
import PaymentDailog from './ledgerEntry/paymentDailog'
import UserTypeShimmer from '../../utils/ui_components/shimmers/userTypeShimmer'
import { Search as SearchIcon } from '@mui/icons-material'
import {
  useFetchCustomer,
  useSearchCustomer
} from '../../modules/customer/customerHooks'
import {
  useCreditRepay,
  useFetchAllLedgerEntry,
  useFetchLatestLedgerEntry,
  useFetchTbpBillAmount
} from '../../modules/ledger/ledgerHooks'
import _ from 'lodash'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'

function LedgerEntry() {
  const jumpToInputRef = useRef(null)
  const searchInputRef = useRef(null)
  const [searchAutoFocus, setSearchAutoFocus] = useState(false)
  const [jumpAutoFocus, setJumpAutoFocus] = useState(false)
  const [shouldScrollToTop, setShouldScrollToTop] = useState(false)
  const [values, setValues] = useState()
  const [page, setPage] = useState(1)
  const [pagecount, setPageCount] = useState(0)
  const [limit, setLimit] = useState(15)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [ledgerId, setLedgerId] = useState()
  const [isSearchMode, setIsSearchMode] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [ledgerEntryDailog, setLedgerEntryDialog] = useState(false)
  const [ledgerEntryPage, setLedgerEntryPage] = useState(1)
  const [ledgerEntryPageCount, setLedgerEntryPageCount] = useState(0)
  const [ledgerEntryLimit, setLedgerEntryLimit] = useState(15)
  const [showPopDialog, setShowPopDialog] = useState(false)
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)

  const {
    fetchCustomer,
    fetchCustomerData,
    fetchCustomerError,
    fetchCustomerLoading
  } = useFetchCustomer()
  const {
    searchCustomer,
    searchCustomerData,
    searchCustomerError,
    searchCustomerLoading
  } = useSearchCustomer()
  const {
    fetchAllLedgerEntryData,
    fetchAllLedgerEntryError,
    fetchAllLedgerEntryHook,
    fetchAllLedgerEntryLoading
  } = useFetchAllLedgerEntry()
  const {
    fetchLatestLedgerEntryHook,
    fetchLatestLedgerEntryData,
    fetchLatestLedgerEntryLoading,
    fetchLatestLedgerEntryError
  } = useFetchLatestLedgerEntry()
  const { fetchTbpBillAmountHook, fetchTbpBillAmountData } =
    useFetchTbpBillAmount()
  const { creditRepayHook } = useCreditRepay()
  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()
  const [selectedOutlet, setSelectedOutlet] = useState(0)
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const history = useNavigate()
  useEffect(() => {
    pageLoad()
  }, [])

  const handlePageChange = async (event, value) => {
    setPage(value)
    if (isSearchMode) {
      let payload = {
        pageNumber: value,
        limit: limit,
        searchQuery: searchValue,
        withLedger: true
      }
      searchCustomer(payload)
    } else {
      let payload = {
        pageNumber: value,
        limit: limit,
        withLedger: true,
        getAllBalance: true
      }
      fetchCustomer(payload)
    }
  }

  const handleLedgerEntryPageChange = async (value) => {
    setLedgerEntryPage(value.page)
    let payload = {
      ledger_id: ledgerId,
      pageNumber: value.page,
      limit: ledgerEntryLimit,
      outlet_id: value.outletId
    }
    fetchAllLedgerEntryHook(payload)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
      // Trigger scroll to top
      setShouldScrollToTop(true)
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const pageCountLedgerEntry = (data1) => {
    let count = Math.ceil(data1 / ledgerEntryLimit)
    setLedgerEntryPageCount(count)
  }

  const pageLoad = () => {
    businessCheck(history)
    let payload = {
      pageNumber: page,
      limit: limit,
      withLedger: true,
      getAllBalance: true
    }
    fetchCustomer(payload)
    payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }

  useEffect(() => {
    if (fetchCustomerData.data?.length > 0) {
      pageCount(fetchCustomerData.total)
      // Scroll to top if triggered by Go button
      if (shouldScrollToTop) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        setShouldScrollToTop(false)
        setJumpAutoFocus(false)
        setSearchAutoFocus(true)
        setTimeout(() => {
          if (searchInputRef.current) {
            searchInputRef.current.focus()
          }
        }, 500)
      }
    } else {
      setPageCount(0)
    }
  }, [fetchCustomerData])

  useEffect(() => {
    if (fetchAllLedgerEntryData.data?.data.length > 0) {
      pageCountLedgerEntry(fetchAllLedgerEntryData.data?.total)
    } else {
      pageCountLedgerEntry(0)
    }
  }, [fetchAllLedgerEntryData.data?.data])

  useEffect(() => {
    if (searchCustomerData.data?.length > 0) {
      pageCount(searchCustomerData.total)
      // Scroll to top if triggered by Go button
      if (shouldScrollToTop) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        setShouldScrollToTop(false)
        setJumpAutoFocus(false)
        setSearchAutoFocus(true)
        setTimeout(() => {
          if (searchInputRef.current) {
            searchInputRef.current.focus()
          }
        }, 500)
      }
    } else {
      setPageCount(0)
    }
  }, [searchCustomerData])

  const fetchLedgerDetails = (
    ledgerId,
    pageNo,
    limit,
    customerId,
    outletId
  ) => {
    let payload = {
      ledger_id: ledgerId,
      pageNumber: pageNo,
      limit: limit,
      outlet_id: outletId
    }
    fetchAllLedgerEntryHook(payload)
    payload = {
      ledger_id: ledgerId,
      outlet_id: outletId
    }
    fetchLatestLedgerEntryHook(payload)
    payload = {
      customer_id: customerId,
      outlet_id: outletId
    }
    fetchTbpBillAmountHook(payload)
  }

  const CustomerListUI = ({ customer }) => (
    <MainCard
      sx={{
        mt: 1,
        p: 2,
        alignItems: 'center',
        transition: 'box-shadow 0.3s ease',
        borderRadius: 1,
        '&:hover': {
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <Grid container column={6} spacing={1}>
        <Grid item>
          <Avatar {...stringAvatar(customer?.name)} />
        </Grid>
        <Grid item xs md>
          <Grid
            container
            direction="column"
            sx={{
              pl: 1,
              cursor: 'pointer'
            }}
            onClick={() => {
              setLedgerEntryDialog(true)
              setLedgerId(customer?.ledger._id)
              setValues(customer)
              setSelectedOutlet(outletFetchData?.data[0]?._id)
              fetchLedgerDetails(
                customer?.ledger._id,
                ledgerEntryPage,
                ledgerEntryLimit,
                customer?._id,
                outletFetchData?.data[0]?._id
              )
            }}
          >
            <Grid item>
              <Grid container justifyContent={'space-between'}>
                <Grid item>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontWeight: 'bold' }}
                  >
                    {customer?.name}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    variant="body1"
                    fontWeight={'bold'}
                    sx={{ color: 'text.secondary' }}
                  >
                    ₹ {customer?.balance_amount}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                <Phone
                  color="success"
                  sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 'medium' }}
                />{' '}
                {customer?.mobile}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </MainCard>
  )

  return (
    <>
      <Helmet title="Ledger Entry" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={9} md={6}>
          <Typography variant="h4" gutterBottom display="inline">
            Ledger Entries
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 5 }} />
      {(fetchCustomerLoading || searchCustomerLoading) && (
        <UserTypeShimmer shimmerCount={[1, 3, 5]} />
      )}
      {fetchCustomerError || searchCustomerError ? (
        <ErrorScreen onClick={pageLoad} />
      ) : (
        !fetchCustomerLoading &&
        !searchCustomerLoading && (
          <Grid container spacing={5} sx={{ paddingTop: 5 }}>
            <Grid item xs sm md>
              <Box sx={{ margin: 2 }}>
                <Card raised sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <MainCard sx={{ width: 300 }}>
                      <Search>
                        <SearchIconWrapper>
                          <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                          inputRef={searchInputRef}
                          placeholder="Search Customer by Name or Mobile"
                          inputProps={{
                            'aria-label': 'search'
                          }}
                          fullWidth
                          autoFocus={searchAutoFocus}
                          value={searchValue}
                          onFocus={(e) => {
                            setSearchAutoFocus(true)
                            setJumpAutoFocus(false)
                            const scrollPos = window.pageYOffset
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          onKeyDown={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            if (e.key === 'Enter') {
                              if (e.target.value) {
                                setPage(1)
                                setIsSearchMode(true)
                                let payload = {
                                  pageNumber: 1,
                                  limit: limit,
                                  searchQuery: e.target.value,
                                  withLedger: true,
                                  getAllBalance: true
                                }
                                searchCustomer(payload)
                              }
                            }
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          onChange={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            setSearchValue(e.target.value)
                            if (!e.target.value && isSearchMode) {
                              setPage(1)
                              setIsSearchMode(false)
                              let payload = {
                                pageNumber: 1,
                                limit: limit,
                                withLedger: true,
                                getAllBalance: true
                              }
                              fetchCustomer(payload)
                            }
                            window.scrollTo(0, scrollPos)
                          }}
                          onInput={(e) => {
                            const scrollPos = window.pageYOffset
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                        />
                      </Search>
                    </MainCard>
                    {isSearchMode && searchCustomerData?.data?.length === 0 ? (
                      <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ minHeight: '30vh', pt: 5 }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h6" gutterBottom align="center">
                            No Records Found
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            align="center"
                          >
                            No ledger entries match your search criteria
                          </Typography>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid
                        sx={{ mt: 1 }}
                        container
                        columns={6}
                        rowSpacing={3}
                        columnSpacing={3}
                      >
                        {isSearchMode
                          ? searchCustomerData?.data?.map((customer) => (
                              <Grid
                                item
                                xs={6}
                                sm={3}
                                md={2}
                                key={customer._id}
                              >
                                <CustomerListUI customer={customer} />
                              </Grid>
                            ))
                          : fetchCustomerData?.data?.map((customer) => (
                              <Grid
                                item
                                xs={6}
                                sm={3}
                                md={2}
                                key={customer._id}
                              >
                                <CustomerListUI customer={customer} />
                              </Grid>
                            ))}
                      </Grid>
                    )}
                  </CardContent>
                  {pagecount > 1 && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        p: 2,
                        backgroundColor: 'grey.50',
                        borderRadius: 1
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          width: '100%'
                        }}
                      >
                        <Pagination
                          count={pagecount}
                          page={page}
                          color="secondary"
                          size="small"
                          boundaryCount={2}
                          siblingCount={0}
                          showFirstButton
                          showLastButton
                          onChange={handlePageChange}
                          sx={{
                            '& .MuiPaginationItem-root': {
                              transition: 'all 0.2s ease-in-out'
                            }
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: 1.5,
                          backgroundColor: 'white',
                          p: 2,
                          borderRadius: 1,
                          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                          transition: 'box-shadow 0.2s ease-in-out',
                          '&:hover': {
                            boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                          }
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: 'text.secondary', fontWeight: 500 }}
                        >
                          Jump to
                        </Typography>
                        <TextField
                          inputRef={jumpToInputRef}
                          size="small"
                          autoFocus={jumpAutoFocus}
                          value={goToPageInput}
                          onFocus={(e) => {
                            setJumpAutoFocus(true)
                            setSearchAutoFocus(false)
                            const scrollPos = window.pageYOffset
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          onChange={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            handleGoToPageChange(e)
                            window.scrollTo(0, scrollPos)
                          }}
                          onKeyPress={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            handleGoToPageKeyPress(e)
                            window.scrollTo(0, scrollPos)
                          }}
                          placeholder="Page"
                          onKeyDown={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            if (
                              [
                                'ArrowUp',
                                'ArrowDown',
                                'PageUp',
                                'PageDown',
                                'Home',
                                'End'
                              ].includes(e.key)
                            ) {
                              e.preventDefault()
                            }
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          onInput={(e) => {
                            const scrollPos = window.pageYOffset
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          inputProps={{
                            style: { textAlign: 'center' }
                          }}
                          sx={{
                            width: '80px',
                            '& .MuiOutlinedInput-root': {
                              backgroundColor: 'white',
                              transition: 'all 0.2s ease-in-out',
                              '& fieldset': {
                                borderColor: 'grey.300',
                                borderWidth: '1px'
                              },
                              '&:hover fieldset': {
                                borderColor: 'secondary.main',
                                borderWidth: '1.5px'
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: 'secondary.main',
                                borderWidth: '2px',
                                boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.1)'
                              }
                            },
                            '& .MuiOutlinedInput-input': {
                              textAlign: 'center',
                              fontWeight: 500,
                              padding: '7px 8px',
                              height: '20px',
                              lineHeight: '20px'
                            }
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: 'text.secondary', fontWeight: 400 }}
                        >
                          of {pagecount}
                        </Typography>
                        <Button
                          variant="contained"
                          color="secondary"
                          size="small"
                          onClick={(e) => {
                            e.preventDefault()
                            handleGoToPageSubmit()
                          }}
                          onMouseDown={(e) => e.preventDefault()}
                          disableFocusRipple
                          disabled={
                            !goToPageInput ||
                            parseInt(goToPageInput, 10) < 1 ||
                            parseInt(goToPageInput, 10) > pagecount
                          }
                          sx={{
                            textTransform: 'none',
                            fontWeight: 500,
                            px: 2,
                            py: 0.75,
                            height: '34px',
                            lineHeight: 1,
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                              transform: 'translateY(-1px)',
                              boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                            },
                            '&:active': {
                              transform: 'translateY(0)'
                            }
                          }}
                        >
                          Go
                        </Button>
                      </Box>
                    </Box>
                  )}
                </Card>
              </Box>
            </Grid>
          </Grid>
        )
      )}
      <LedgerEntryDialog
        visible={ledgerEntryDailog}
        handleClose={() => {
          setLedgerEntryPage(1)
          setLedgerEntryDialog(false)
        }}
        initialValues={_.cloneDeep(fetchAllLedgerEntryData.data?.data)}
        customerData={values}
        latestEntryData={_.cloneDeep(fetchLatestLedgerEntryData)}
        loading={fetchAllLedgerEntryLoading}
        latestLoading={fetchLatestLedgerEntryLoading}
        page={ledgerEntryPage}
        pagecount={ledgerEntryPageCount}
        tbpAmount={_.cloneDeep(fetchTbpBillAmountData?.data)}
        handlePageChange={handleLedgerEntryPageChange}
        showPaymentWindow={() => setShowPopDialog(true)}
        pageReload={pageLoad}
        error={fetchAllLedgerEntryError || fetchLatestLedgerEntryError}
        onOutletChange={(outletId) => {
          setSelectedOutlet(outletId)
          fetchLedgerDetails(
            ledgerId,
            ledgerEntryPage,
            ledgerEntryLimit,
            values?._id,
            outletId
          )
        }}
      />
      <PaymentDailog
        showpopDialog={showPopDialog}
        closeWindow={() => setShowPopDialog(false)}
        paymentValues={_.cloneDeep(fetchLatestLedgerEntryData)}
        tbpAmount={_.cloneDeep(fetchTbpBillAmountData?.data)}
        onSubmit={async (values) => {
          let data = {
            paid_amount: parseInt(values.amount),
            ledger_id: ledgerId,
            remarks: values.remarks,
            outlet_id: selectedOutlet
          }
          await creditRepayHook(data, (success, error, message) => {
            if (error) {
              toastMessage(message, 'error')
            } else {
              toastMessage('Payment Successful', 'success')
              setShowPopDialog(false)
              let payload = {
                ledger_id: ledgerId,
                outlet_id: selectedOutlet
              }
              fetchLatestLedgerEntryHook(payload)
              payload = {
                ledger_id: ledgerId,
                outlet_id: selectedOutlet,
                pageNumber: ledgerEntryPage,
                limit: ledgerEntryLimit
              }
              fetchAllLedgerEntryHook(payload)
            }
          })
        }}
      />
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}

export default LedgerEntry
